/**
 * Webflow Interactions Helper
 * Ensures that Webflow interactions and animations work correctly in the Shopify theme
 */

(function() {
  // Wait for DOM to be fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize after a short delay to ensure Webflow.js is loaded
    setTimeout(initializeWebflowInteractions, 300);
  });

  function initializeWebflowInteractions() {
    // Check if Webflow is available
    if (!window.Webflow) {
      console.error('Webflow JS not found. Attempting to fix interactions manually.');
      fixInteractionsManually();
      return;
    }

    // Ensure IX2 is initialized
    ensureIX2Initialized();
    
    // Fix marquee animations
    fixMarquees();
    
    // Fix sliders/carousels
    fixSliders();

    // Log animation elements for debugging
    logAnimationElements();
  }

  function ensureIX2Initialized() {
    try {
      if (window.Webflow && window.Webflow.require) {
        const ix2 = window.Webflow.require('ix2');
        if (ix2 && typeof ix2.init === 'function') {
          ix2.init();
          console.log('IX2 initialized by helper script');
        }
      }
    } catch (error) {
      console.error('Error initializing IX2:', error);
    }
  }

  function fixInteractionsManually() {
    // Find all elements with data-w-id attributes
    const animatedElements = document.querySelectorAll('[data-w-id]');
    console.log(`Found ${animatedElements.length} elements with data-w-id attributes`);

    // Apply basic animations based on transform styles
    animatedElements.forEach(element => {
      const style = element.getAttribute('style') || '';
      
      // If element has transform styles, it might be an animated element
      if (style.includes('transform')) {
        // Add hover effects where appropriate
        element.addEventListener('mouseenter', function() {
          // Apply hover state if the element has rotation
          if (style.includes('rotateZ')) {
            element.style.transform = 'rotateZ(10deg)';
          }
          // Apply hover state if the element has scale
          if (style.includes('scale')) {
            element.style.transform = 'scale(1.1)';
          }
        });

        element.addEventListener('mouseleave', function() {
          // Reset to original state
          element.setAttribute('style', style);
        });
      }
    });
  }

  function fixMarquees() {
    // Fix marquee animations if they exist
    const marquees = document.querySelectorAll('.marquee-horizontal, .marquee-vertical');
    marquees.forEach(marquee => {
      const track = marquee.querySelector('.track-horizontal-alts, .track-vertical-alts');
      if (track) {
        // Ensure the track has proper animation
        if (getComputedStyle(track).animationName === 'none') {
          // Clone the track content to ensure it's long enough for seamless scrolling
          track.innerHTML = track.innerHTML + track.innerHTML;
          
          // Apply animation if it's not already applied
          if (track.classList.contains('track-horizontal-alts')) {
            track.style.animation = 'marquee-horizontal-alt 45s linear infinite';
          } else if (track.classList.contains('track-vertical-alts')) {
            track.style.animation = 'marquee-vertical-alt 45s linear infinite';
          }
        }
      }
    });
  }

  function fixSliders() {
    // Fix slider/carousel functionality
    const sliders = document.querySelectorAll('.w-slider');
    sliders.forEach(slider => {
      const mask = slider.querySelector('.w-slider-mask');
      const slides = slider.querySelectorAll('.w-slide');
      const prevButton = slider.querySelector('.w-slider-arrow-left');
      const nextButton = slider.querySelector('.w-slider-arrow-right');
      
      if (mask && slides.length > 0 && prevButton && nextButton) {
        let currentSlide = 0;
        
        // Clone slides for infinite scrolling if needed
        if (slides.length < 3) {
          for (let i = 0; i < slides.length; i++) {
            const clone = slides[i].cloneNode(true);
            mask.appendChild(clone);
          }
        }
        
        // Set up click handlers for navigation arrows
        prevButton.addEventListener('click', function() {
          currentSlide = (currentSlide - 1 + slides.length) % slides.length;
          updateSliderPosition();
        });
        
        nextButton.addEventListener('click', function() {
          currentSlide = (currentSlide + 1) % slides.length;
          updateSliderPosition();
        });
        
        // Function to update slider position
        function updateSliderPosition() {
          const slideWidth = slides[0].offsetWidth;
          mask.style.transform = `translateX(-${currentSlide * slideWidth}px)`;
          mask.style.transition = 'transform 0.5s ease';
        }
      }
    });
  }

  function logAnimationElements() {
    // Log animation elements for debugging
    const animationElements = {
      'data-w-id elements': document.querySelectorAll('[data-w-id]').length,
      'w-slider elements': document.querySelectorAll('.w-slider').length,
      'marquee elements': document.querySelectorAll('.marquee-horizontal, .marquee-vertical').length,
      'hover elements': document.querySelectorAll('.w-hover').length
    };
    
    console.log('Animation elements found:', animationElements);
  }
})(); 